import Subcategories from "@themes/default/components/DetailProductsList/Subcategories";

export default Subcategories;
